export const logarithmicToLinear = (value: number): number => {
  value = Math.max(0, Math.min(100, value));
  if (value === 0) return 0;
  return Math.pow(value / 100, 2) * 100;
};
